import { Component, Inject, OnInit } from '@angular/core';
import { ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-avatar-upload',
    templateUrl: './avatar-upload.component.html',
    styleUrls: ['./avatar-upload.component.scss'],
    imports: [ImageCropperModule, MatButton]
})
export class AvatarUploadComponent implements OnInit {

    private imageBase64: string = null;
    public imageChangedEvent: any;
    public url = null;

    constructor(@Inject(MAT_DIALOG_DATA) data: { url }, private matDialogRef: MatDialogRef<AvatarUploadComponent>) {
        this.url = data.url;
    }

    ngOnInit(): void {
    }

    selectedFile(event: any): void {
        this.imageChangedEvent = event;
    }

    imageCropped(event: ImageCroppedEvent): void {
        this.imageBase64 = event.base64;
    }

    save(): void {
        this.matDialogRef.close(this.imageBase64);
    }

    cancel(): void {
        this.matDialogRef.close(null);
    }

}
